import { StyledButtonGroup } from '@app/components/button-group/ButtonGroup';
import { StyledButton } from '@app/components/button/Button';
import { StyledCard } from '@app/components/card/Card';

export type UserAddWidgetProps = {
	onAdd: () => void;
};

export const UserAddWidget = ({ onAdd }: UserAddWidgetProps) => {
	return (
		<StyledCard size="small">
			<p className="h4">Add a New User</p>

			<p>
				Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
				incididunt ut labore et dolore magna aliqua.
			</p>

			<StyledButtonGroup justify="flex-end">
				<StyledButton type="primary" onClick={onAdd}>
					Add New User
				</StyledButton>
			</StyledButtonGroup>
		</StyledCard>
	);
};
